import { regular, solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tab, Tabs } from '@mui/material';
import React from 'react';
import CompletedTask from '../../components/task-item/CompletedTask.component';
import NotCompletedTask from '../../components/task-item/NotCompletedTask.component';
import './SingleEventContainer.styles.css';
import TaskDetailModalContainer from './TaskDetailModal.container';
import { ReactComponent as EmptyIcon } from '../../assets/images/tasks/empty-icon.svg';
import ProgressBar from '../../components/progress-bar/ProgressBar.component';
import { searchTaskFilter, isSecureUrl } from '../../utils/helperFn';
import useDebounce from '../../hooks/useDebounce';
import { useTranslation } from 'react-i18next';
import moment from "moment";
import CustomDialogBox from "../../components/global/CustomDialogBox.component";
import EmptySearchResult from '../../components/empty-search-result/EmptySearchResult.component';
import { useDispatch } from 'react-redux';
import { openSnackBar } from '../../redux/actions/snackbar.actions';

function EventTabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`eventtabpanel-${index}`}
        aria-labelledby={`event-tab-${index}`}
        {...other}
      >
        {value === index && (
          <div className='cm-tasklist-tab-content-inner col-12 d-flex flex-wrap px-2'>
            {children}
          </div>
        )}
      </div>
    );
}

const SingleEventContainer = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [taskData, setTaskData] = React.useState(null);
    const [tabValue, setTabValue] = React.useState(0);
    const [searchTxt, setSearchTxt] = React.useState('');

    const handleSearch = (searchTerm) => {
        let searchParam = {
            taskStatus: 'allTasks',
            data: props.taskData.candidateAllTaskList
        };

        if(tabValue === 1) {
            searchParam = {
                taskStatus: 'notCompleted',
                data: props.taskData.candidateTaskList
            }
        }

        if(tabValue === 2) {
            searchParam = {
                taskStatus: 'completed',
                data: props.taskData.candidateCompletedTaskList,
            }
        }

        if(searchTerm !== '') {
            setTaskData({
                ...taskData,
                [searchParam.taskStatus]: searchTaskFilter(searchParam.data, searchTerm)
            })
        } else {
            filtertasks();
        }
    }

    // DeBounce Function
    useDebounce(() => {
        if(taskData !== null && (searchTxt.length >= 2 || searchTxt === '')) handleSearch(searchTxt)
    }, [searchTxt], 800);

    React.useEffect(() => {
        filtertasks();
        resetSearchFn();
    }, [tabValue]);

    const filtertasks = () => {
        const completed = [];
        const notCompleted = props.taskData.candidateTaskList;
        setTaskData({
            ...taskData,
            count: props.taskData.count,
            eventId: props.taskData.eventId,
            completed: props.taskData.candidateCompletedTaskList,
            notCompleted : notCompleted.filter((el)=>el?.taskControl !== "HIDE"),
            allTasks: props.taskData.candidateAllTaskList
        })
    }

    const handleChange = (e) => {
        setSearchTxt(e.target.value)
    }

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const loadTask = (tabType, data, index, hasAllGroupBlocked) => {
        if(tabType === "YET_TO_START") {
            return <NotCompletedTask
                t={t}
                data={data}
                key={index}
                eventId={taskData.eventId}
                joinModalData={props.joinModalData}
                joinModalDataHandler={props.joinModalDataHandler}
                hasAllGroupBlocked={hasAllGroupBlocked}
            />
        }

        if(tabType === "COMPLETED") {
            return <CompletedTask t={t} data={data} key={index} eventId={taskData.eventId} />
        }

        return null;
    }

    const loadAllTasks = (arr="allTasks") => {
        return taskData[arr].map((el, index) => {
            if(el.taskType === null && el.candidateTaskList?.length > 0) {
                return (<div key={arr + "-" + `${el.id ? el.id : `${el.name}-${el.orderId}`}`} className="px-4 py-3 rounded bg-blue-gray-50 mb-4" style={{ width: "calc(100% - 8px)" }}>
                    <p className="mb-12 text-blue-800 fw-medium px-2">{el.name}</p>
                    <div className='d-flex flex-wrap'>
                        {el.candidateTaskList.map((innerEl, innerIndex) => {
                            if(tabValue === 0) return loadTask(innerEl.taskTab, innerEl, innerIndex ,el.candidateTaskList[0].block);
                            if(tabValue === 1) return innerEl.taskTab === "YET_TO_START" && loadTask("YET_TO_START", innerEl, innerIndex, el.candidateTaskList[0].block);
                            if(tabValue === 2) return innerEl.taskTab === "COMPLETED" && loadTask("COMPLETED", innerEl, innerIndex, el.candidateTaskList[0].block);
                            return null
                        } )}
                    </div>
                </div>)
            } else {
                if(tabValue === 0) return loadTask(el.taskTab, el, index);
                if(tabValue === 1) return el.taskTab === "YET_TO_START" &&  loadTask("YET_TO_START", el, index);
                if(tabValue === 2) return el.taskTab === "COMPLETED" &&  loadTask("COMPLETED", el, index);
                return null;
            }
        })
    }

    const loadIncompleteTasks = () => loadAllTasks("notCompleted");

    const completedTasks = () => loadAllTasks("completed");

    const resetSearchFn = () => {
        setSearchTxt('');
    }

    const openEvent = () =>{
        // Security: Validate URL to prevent Open Redirect (CWE-601)
        const secureUrl = isSecureUrl(props.joinModalData.interviewLink, dispatch, t);
        if (!secureUrl) {
            props.joinModalDataHandler({...props.joinModalData,customDialogBoxToggle:false});
            return;
        }
        // Safe: URL has been validated above
        window.open(secureUrl, "_blank");
        props.joinModalDataHandler({...props.joinModalData,customDialogBoxToggle:false})
    }
    const modalStaticData = React.useMemo(
      () => ({
        INTERVIEW: {
          heading: "join_interview",
          body: "you_can_join_the_interview_by_clicking_the_join",
          bannerText: "this_interview_is_scheduled_to_start_on"
        },
        GROUP_DISCUSSION: {
          heading: "join_gd",
          body: "you_can_join_the_gd_by_clicking_the_join",
          bannerText: "this_gd_is_scheduled_to_start_on"
        },
      }),
      [t]
    );
    return(
        <div className='cm-single-event-container'>
            {
                taskData !== null ?
                <>
                    <div className="cm-av-tasks-header bg-white px-4">
                        <div className="px-3 d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center text-blue-gray-700 cm-av-tasks-header-title">
                                <Tabs value={tabValue} onChange={handleTabChange} className="cm-task-event-tab-nav bg-blue-gray-50">
                                        <Tab label={<span className='cm-truncate-1'>{t('all')} ({taskData.count.notCompletedTabCount + taskData.count.completedTabCount})</span>} icon={<FontAwesomeIcon icon={tabValue === 0 ? solid("grid-2") : regular('grid-2')} />} iconPosition="start" disableRipple className="cm-task-event-tab text-blue-gray-700 fw-medium" />
                                    <Tab label={<span className='cm-truncate-1'>{t('yet_to_start')} ({taskData.count.notCompletedTabCount})</span>} icon={<FontAwesomeIcon icon={tabValue === 1 ? solid("timer") : regular('timer')} />} iconPosition="start" disableRipple className="cm-task-event-tab text-blue-gray-700 fw-medium" />
                                    <Tab label={<span className='cm-truncate-1'>{t('completed')} ({taskData.count.completedTabCount})</span>} icon={<FontAwesomeIcon icon={tabValue === 2 ? solid('check-circle') : regular('check-circle')} />} iconPosition="start" disableRipple className="cm-task-event-tab cm-truncate-1 text-blue-gray-700 fw-medium" />
                                </Tabs>
                            </div>
                            <div className="position-relative cm-av-tasks-search-wrap">
                                <input type="text" value={searchTxt} onChange={handleChange} className="form-control cm-sm-txt text-blue-gray-700" id="avTaskSearch" placeholder={t("task_search_placeholder")} />
                                <FontAwesomeIcon icon={regular("search")} className="position-absolute text-gray-500 cm-av-tasks-submit" />
                            </div>
                        </div>
                    </div>
                    <div className="cm-av-tasks-content bg-white px-4">
                        <EventTabPanel value={tabValue} index={0}>
                            {
                                taskData.allTasks.length > 0 ? loadAllTasks() : 
                                <div className='cm-empty-tasklist-tab text-center col-12'>
                                    {searchTxt !== '' ? 
                                    <EmptySearchResult searchTerm={searchTxt} resetSearchFn={resetSearchFn} /> :
                                    <>
                                        <EmptyIcon />
                                        <div className="cm-content">
                                            <p className='mt-3 fw-semibold text-blue-700 my-0'>{t("nothing_more_to_do")} <span className='d-block mt-2 cm-sm-txt text-blue-gray-500 fw-medium'>{t("all_tasks_completed")}</span></p>
                                            <span className='px-12 py-2 border border border-blue-gray-300 cm-btn-radius bg-white text-blue-800 mb-0 d-inline-block mt-3 cm-pointer cm-light-hover' onClick={(e) => handleTabChange(e, 1)}><span className='cm-sm-txt fw-medium pe-2'>{t("view_completed_tasks")}</span><FontAwesomeIcon icon={regular("angle-right")} /></span>
                                        </div>
                                    </>
                                    }
                                </div>
                            }
                        </EventTabPanel>
                        <EventTabPanel value={tabValue} index={1}>
                            {
                                taskData.notCompleted.length > 0 ? loadIncompleteTasks() : 
                                <div className='cm-empty-tasklist-tab text-center col-12'>
                                    {searchTxt !== '' ? 
                                    <EmptySearchResult searchTerm={searchTxt} resetSearchFn={resetSearchFn} /> :
                                    <>
                                        <EmptyIcon />
                                        <div className="cm-content">
                                            <p className='mt-3 fw-semibold text-blue-700 my-0'>{t("nothing_more_to_do")} <span className='d-block mt-2 cm-sm-txt text-blue-gray-500 fw-medium'>{t("all_tasks_completed")}</span></p>
                                            <span className='px-12 py-2 border border border-blue-gray-300 cm-btn-radius bg-white text-blue-800 mb-0 d-inline-block mt-3 cm-pointer cm-light-hover' onClick={(e) => handleTabChange(e, 1)}><span className='cm-sm-txt fw-medium pe-2'>{t("view_completed_tasks")}</span><FontAwesomeIcon icon={regular("angle-right")} /></span>
                                        </div>
                                    </>
                                    }
                                </div>
                            }
                        </EventTabPanel>
                        <EventTabPanel value={tabValue} index={2}>
                            {
                                taskData.completed.length > 0 ? completedTasks() : 
                                <div className='cm-empty-tasklist-tab text-center col-12'>
                                    {searchTxt !== '' ? 
                                    <EmptySearchResult searchTerm={searchTxt} resetSearchFn={resetSearchFn} /> :
                                    <>
                                        <EmptyIcon />
                                        <div className="cm-content">
                                            <p className='mt-3 fw-semibold text-blue-700 my-0'>{t("nothing_more_to_do")} <span className='d-block mt-2 cm-sm-txt text-blue-gray-500 fw-medium'>{t("you_can_view_your_pending_tasks")}</span></p>
                                            <span className='px-12 py-2 border border border-blue-gray-300 cm-btn-radius bg-white text-blue-800 mb-0 d-inline-block mt-3 cm-pointer cm-light-hover' onClick={(e) => handleTabChange(e, 0)}><span className='cm-sm-txt fw-medium pe-2'>{t("view_yet_to_start_tasks")}</span><FontAwesomeIcon icon={regular("angle-right")} /></span>
                                        </div>
                                    </>
                                    }
                                </div>
                            }
                        </EventTabPanel>
                    </div>
                        <TaskDetailModalContainer eventData={{ eventId: props.taskData.eventId, startDate: props.taskData.startDate, endDate: props.taskData.endDate }} joinModalData={props.joinModalData} joinModalDataHandler={props.joinModalDataHandler} />
                </>
                : <div className='p-4'>
                    <ProgressBar />
                </div>
            }
            <CustomDialogBox
                t={t}
                dialogHeading={t(modalStaticData[props.joinModalData.taskType]?.heading)}
                cancelFn={()=>{props.joinModalDataHandler({...props.joinModalData,customDialogBoxToggle:false})}}
                dialogStatus={props.joinModalData.customDialogBoxToggle}
                disabled={false}
                buttonArrayData={[
                {
                    btnName: "cancel",
                    cssSty:
                    "text-blue-800 cm-sm-txt fw-medium border border-blue-gray-300",
                    handleBtnClick: () => {props.joinModalDataHandler({...props.joinModalData,customDialogBoxToggle:false})},
                },
                { 
                    btnName: "join_now",
                    cssSty:
                    "cm-blue-btn cm-sm-txt cm-trans-btn d-flex flex-row-reverse ms-2 cm-mar-left-icon",
                    icon: regular("angle-right"),
                    handleBtnClick: () => {openEvent()},
                },
                ]}
            >
            {!!props.joinModalData?.taskStartDate && (
                <div className="d-flex py-10 px-4 cm-sm-txt cm-background-light-color cm-btn-radius mb-4">
                <FontAwesomeIcon
                    icon={regular("clock")}
                    className="me-1 p-1 text-blue-800"
                />
                <p className="mb-0">
                    {t(modalStaticData[props.joinModalData.taskType]?.bannerText)}
                    {/* {props.joinModalData.taskType ==='INTERVIEW'?t("this_interview_is_scheduled_to_start_on"):t("this_gd_is_scheduled_to_start_on")} */}
                    <strong>
                    {" " +
                        moment(props.joinModalData.taskStartDate)
                        .format("MMM DD YYYY") +
                        " "}
                    </strong>
                    {t("at")}
                    <strong>
                    {" " +
                        moment(props.joinModalData.taskStartDate).format("hh:mm A")}
                    </strong>
                    . 
                </p>
                </div>
            )}
            <p className="mb-4 cm-sm-txt">
                {t(modalStaticData[props.joinModalData.taskType]?.body)}
                {/* {props.joinModalData.taskType ==='INTERVIEW'?t("you_can_join_the_interview_by_clicking_the_join"):t("you_can_join_the_gd_by_clicking_the_join")} */}
            </p>
            </CustomDialogBox>
        </div>
    )

}

export default SingleEventContainer;